export default __webpack_public_path__ + "static/media/icon.4f21b3c1.png";